import React, { useState } from "react";
import { Button } from "@mui/material";
import { MyLabInput } from "./Utils/addMyLabs";
import {
  useAddMyLabMutation,
  useUpdateMyLabMutation,
} from "../../../../Service/LabManagement";
import useSnackbar from "../../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../../Component/DigitalMarketing/Toast";
import { useSelector } from "react-redux";

const MyLabsDetails = (props) => {
  const { updateData, view, setShow, branchOptions, refetch } =
    props;
  const account = useSelector((state: any) => state.auth);
  const { roleName } = account
  const [formData, setFormData] = useState({
    id: updateData?.id || "",
    labName: updateData?.labName || "",
    email: updateData?.email || "",
    phone: updateData?.phone || "",
    password: updateData?.password || "",
    branchId: updateData?.branchId || "",
    activeStatus: updateData?.activeStatus || "",
  });

  const { open, message, openSnackBar, type } = useSnackbar();

  const [submit, setSubmit] = useState(false);
  const handleChangeInfo = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    let { name, value } = e.target;

    if (name === 'email') {
      value = value.replace(/[^a-zA-Z0-9@._-]/g, '');
    }
    else if (name === 'phone') {
      value = value.replace(/[^0-9]/g, '');
      value = value.slice(0, 10);
    }
    else if(name !=='password'){
       value = value.replace(/^[\s]+|[^a-zA-Z0-9 ]/g, '');
    }
    setFormData({ ...formData, [name]: value });
  };
  const [addMylab] = useAddMyLabMutation();
  const [updateMyLab] = useUpdateMyLabMutation();
  const handleSubmit = async () => {
    setSubmit(true);

    // Define required fields manually
    const requiredFields = ["labName", "email", "phone"];
    if (!updateData?.id) {
      requiredFields.push("password");
      if (roleName === "super_admin") {
        requiredFields.push("branchId");
      }
    }

    // Check for missing fields
    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      openSnackBar(`Missing required fields: ${missingFields.join(", ")}`, "error");
      return;
    }

    if (!formData?.id) {
      try {
        await addMylab({ ...formData }).unwrap();
        openSnackBar("Created successfully", "success");
        setShow(false);
        refetch();
      } catch (error: any) {
        console.error("Error adding lab:", error);
        openSnackBar(error?.data?.error, "error");
      }
    } else {
      const { activeStatus } = formData;
      const extractedData = { ...formData, activeStatus: activeStatus !== "0" ? "1" : "0" };
      try {
        await updateMyLab({ id: formData.id, ...extractedData }).unwrap();
        openSnackBar("Updated successfully", "success");
        setShow(false);
        refetch();
      } catch (error: any) {
        console.error("Error updating lab:", error);
        openSnackBar(error?.data?.message, "error");
      }
    }
  };


  return (
    <div>
      <Toast open={open} type={type} message={message} />
      {!view && (
        <div className="mt-3">
          <span className="f-18 fw-700">
            {updateData?.id ? "Edit Lab" : "Add New Lab"}
          </span>
        </div>
      )}

      {MyLabInput.map((a, i) => {
        if (
          updateData?.id &&
          (a.name === "password")
        ) {
          return;
        }

        if (a.role && a.role !== roleName) {
          return null;
        }
        else if (a.name === "branchName" && roleName !== "branch") {
          return (
            <div className="input-custom mt-2" key={i}>
              <div className="d-flex justify-content-between mt-2">
                <div>
                  <label className="det-label">Branch Name</label>
                </div>
                <div>
                  <select
                    className="input-custom"
                    name="branchId"
                    value={formData.branchId}
                    onChange={handleChangeInfo}
                    disabled={view}
                  >
                    <option value="">Select Branch</option>
                    {branchOptions?.data?.map((branch) => (
                      <option key={branch.id} value={branch.id}>
                        {branch.branchName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          );
        }
        return (
          <div className="input-custom mt-2" key={i}>
            <a.tag
              img={a.img}
              label={a.label}
              name={a.name}
              value={formData[a.key]}
              handleChange={handleChangeInfo}
              validation={a.validation}
              keyName={a.key}
              submit={submit}
              disabled={view}
            />
          </div>
        );
      })}
      {!view && (
        <div
          className="d-flex justify-content-center mt-4 mb-3"
          onClick={handleSubmit}
        >
          <Button variant="contained" id="btn-save">
            {updateData?.id ? "Update NewLab" : "Create Lab"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default MyLabsDetails;
